<app-shared-apply-now-form
  [domicileId]="domicileId"
  [jobTitle]="jobExperience"
  [jobId]="jobId"
  [jobTitle]="jobTitle"
  *ngIf="!isLoading"
  [recordSource]="recordSource"
></app-shared-apply-now-form>
